import { IconPack } from '@fortawesome/fontawesome-svg-core';
import { withIconComponent } from '@/core/icons';

import {
    faPen,
    faCheck,
    faAngleRight,
    faAngleLeft,
    faTimes,
    faEllipsisH,
    faCheckCircle
} from '@fortawesome/free-solid-svg-icons';

export const AppIconPack: IconPack = {
    faPen,
    faCheck,
    faAngleRight,
    faAngleLeft,
    faTimes,
    faEllipsisH,
    faCheckCircle
};

export const AppIcons = {
    'app-check': withIconComponent(faCheck),
    'app-times': withIconComponent(faTimes),
    'app-inline-edit': withIconComponent(faPen),
    'app-ellipsis-h': withIconComponent(faEllipsisH),
    'app-info-check': withIconComponent(faCheckCircle),
    'app-angle-right': withIconComponent(faAngleRight),
    'app-angle-left': withIconComponent(faAngleLeft)
};
